import { graphql, Link, useStaticQuery } from 'gatsby'
import React from 'react'
import Printable from './Printable'
import * as styles from './QuotePageLayout.module.css'

const query = graphql`
  query Categories {
    allSanityTestimonialCategory {
      nodes {
        id
        title
        slug {
          current
        }
      }
    }
  }
`

export default function QuotePageLayout(props) {
  const data = useStaticQuery(query)

  return (
    <div className="max-w-5xl mx-auto">
      <div className={styles.search}>
        <form
          action="/quotes/search"
          className=" block text-center sm:flex flex-initial space-between"
        >
          <div className="px-5 py-3 ">Search quote by text:</div>
          <input
            required
            minLength={3}
            name="query"
            type="text"
            className="w-full px-5 border py-3 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs border-indigo-500 rounded-md"
            placeholder="Enter text or author name"
          />
          <button
            type="submit"
            className="mt-3 w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-700 focus:ring-white sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0"
          >
            Search
          </button>
        </form>
      </div>
      <div className="block md:flex space-between">
        <div className="w-full md:w-1/3 px-6 mx-6">
          <div className="prose mt-10">
            <h2 className="font-bold">Categories:</h2>
          </div>
          <ul className="md:grid md:grid-cols-1">
            {data.allSanityTestimonialCategory.nodes.map((v, i) => (
              <li>
                <Link
                  className={styles.link}
                  activeClassName={styles.activeLink}
                  key={i}
                  to={`/quotes/category/${v.slug?.current}`}
                >
                  {v.title}
                </Link>
              </li>
            ))}
          </ul>
          {props.showAllButton && (
            <Link className={styles.link} to="/quotes">
              SHOW ALL
            </Link>
          )}
        </div>
        <div className="p-2 w-full md:w-2/3">
          <Printable>{props.children}</Printable>
        </div>
      </div>
    </div>
  )
}
